<template>
  <div class="RLayoutBox">
    <el-row :gutter="40">
      <el-col :span="7" class="PerTreeHeight">
        <el-button
          size="medium"
          style="display: block; margin: 0 auto; width: 76%"
          type="primary"
          icon="el-icon-plus"
          @click="addPower"
          >添加自定义权限</el-button
        >
        <div class="PerLine"></div>
        <el-tree
          :data="treeData"
          :props="treeProps"
          node-key="PowerId"
          :default-expanded-keys="defaultShowNodes"
          :expand-on-click-node="false"
          @node-click="editPower"
        >
          <span slot-scope="{ data }">
            <span :style="{ color: data.IsEnable == '1' ? '' : '#cecece' }">{{
              data.PowerName
            }}</span>
          </span>
        </el-tree>
      </el-col>
      <el-col :span="17" style="padding: 0 16%">
        <div class="FromTitle">
          <div class="FromTitleBorder"></div>
          <div class="FromTitleText">添加自定义权限</div>
        </div>
        <el-form
          ref="form"
          @submit.native.prevent
          :model="form"
          :rules="rules"
          status-icon
          label-position="right"
          label-width="100px"
        >
          <el-form-item label="权限种类" prop="PowerKind">
            <DataDic
              v-model="form.PowerKind"
              type="PowerKind"
              @input="PowerKindChange"
            ></DataDic>
          </el-form-item>
          <el-form-item label="上级权限" prop="PowerParent">
            <DataDic v-model="form.PowerParent" :type="PowerParent"></DataDic>
          </el-form-item>
          <el-form-item label="权限编码" prop="PowerCode">
            <el-input
              v-model.trim="form.PowerCode"
              placeholder="权限编码"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="权限名称" prop="PowerName">
            <el-input
              v-model.trim="form.PowerName"
              placeholder="权限名称"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="权限顺序" prop="PowerOrder">
            <el-input
              v-model.number="form.PowerOrder"
              placeholder="权限顺序"
              clearable
            ></el-input>
          </el-form-item>

          <el-form-item label="权限URL" prop="PowerUrl">
            <el-input
              v-model.trim="form.PowerUrl"
              placeholder="权限URL"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="权限图标" prop="PowerIcon">
            <el-input
              v-model.trim="form.PowerIcon"
              placeholder="权限图标"
              clearable
            ></el-input>
          </el-form-item>

          <el-form-item label="是否启用" prop="IsEnable">
            <DataDic v-model="form.IsEnable" type="YesOrNo"></DataDic>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="save">保存</el-button>

            <el-button type="danger" @click="removePower" v-if="isEdit"
              >删除</el-button
            ><el-button type="canale" @click="resetForm">重置</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      treeProps: {
        label: "PowerName",
      },
      PowerList: [],
      form: {},
      rules: {
        PowerKind: [this.$g.validRequired],
        PowerCode: [this.$g.validRequired, this.$g.validLen(50)],
        PowerName: [this.$g.validRequired, this.$g.validLen(16)],
        PowerOrder: [this.$g.validRequired, this.$g.validNumber],
        PowerIcon: [this.$g.validLen(32), this.$g.validChinese],
        PowerUrl: [this.$g.validLen(64)],
        IsEnable: [this.$g.validRequired],
      },
    };
  },
  computed: {
    treeData() {
      return this.$g.listToTree(this.PowerList, "PowerId", "PowerParent");
    },
    PowerParent() {
      //没有选择或选的菜单组，上级权限选项为空
      if (!this.form.PowerKind || this.form.PowerKind == "1") {
        return [];
      }
      //权限为菜单的，上级权限为菜单组；权限为功能的，上级权限为菜单
      let res = this.PowerList.filter(
        (r) =>
          (this.form.PowerKind == "2" && r.PowerKind == "1") ||
          (this.form.PowerKind == "3" && r.PowerKind == "2")
      ).map((r) => {
        return {
          code: r.PowerId,
          name: r.PowerName,
        };
      });
      return res;
    },
    defaultShowNodes() {
      let top = this.PowerList.find((r) => !r.PowerParent);
      if (!top) {
        return [];
      } else {
        return [top.PowerId];
      }
    },
    isEdit() {
      if (this.form.PowerId) {
        return true;
      } else {
        return false;
      }
    },
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.$get("Power/GetList").then((r) => {
        this.PowerList = r.Result;
      });
    },
    PowerKindChange() {
      this.$set(this.form, "PowerParent", "");
    },
    addPower() {
      this.resetFields();
      this.form = {};
    },
    editPower(data) {
      this.resetFields();
      this.form = { ...data };
    },
    save() {
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          return;
        }
        let values = { ...this.form };
        if (this.isEdit) {
          this.$put("Power/Edit", values).then((r) => {
            this.$message.success("修改成功");
            this.resetFields();
            this.getData();
          });
        } else {
          this.$post("Power/Add", values).then((r) => {
            this.$message.success("添加成功");
            this.resetFields();
            this.getData();
          });
        }
      });
    },
    removePower() {
      if (this.form.children) {
        this.$message.error("存在子节点，不能删除，请先删除此节点下的子节点");
        return;
      }

      this.$confirm(`将删除此权限, 是否继续?`, "提示信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "el-button--canale",
        type: "warning",
      })
        .then(() => {
          this.$delete("Power/Delete", {
            PowerId: this.form.PowerId,
          }).then((r) => {
            this.$message.success("删除成功");
            this.resetFields();
            this.getData();
          });
        })
        .catch(() => {});
    },
    resetFields() {
      if (this.$refs["form"]) {
        this.form = {};
        this.$refs["form"].resetFields();
      }
    },
    resetForm(){}
  },
};
</script>

<style lang="scss" scoped>
.RLayoutBox {
  height: calc(100vh - 114px) !important;
  overflow-y: auto;
  overflow-x: hidden;
}
.el-tree {
  height: calc(100vh - 190px - 6px - 15px);
  overflow-y: auto;
  margin: 0 10px;
}
</style>